import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { ManagedCardService } from "./managecards.service";
import { ReduntantCard, ReduntantCardModel } from "./managecards";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { ApiEndPoints } from "../api.endpoints";
import { LoaderService } from "../LoaderService";

declare var $: any;

@Component({
  templateUrl: "./managedcards.reduntantcards.component.html"
})
export class ReduntantCardsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Manage Cards';
  public managedCardsName: string = 'reduntantcards';
  public reduntantCardsList: ReduntantCard[];
  public accessAccounts: IAccount[];
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private managedCardService: ManagedCardService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.accessAccounts = this.authService.getSelectedAccessAccounts();
    this.loadReduntantCardsList();
    this.datefilerInitiate();
  }

  datefilerInitiate() {
    $(document).ready(function () {
      jQuery.extend($.fn.dataTableExt.oSort, {
        "date-uk-pre": function (a) {
          if (a == null || a == "") {
            return 0;
          }
          var ukDatea = a.split('-');
          return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
        },

        "date-uk-asc": function (a, b) {
          return ((a < b) ? -1 : ((a > b) ? 1 : 0));
        },

        "date-uk-desc": function (a, b) {
          return ((a < b) ? 1 : ((a > b) ? -1 : 0));
        }
      });
    });
  }

  ngAfterViewInit(): void {
    $.extend($.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == null || str1 == "")
          return 1;
        if (str2 == null || str2 == "")
          return -1;
        return ((str1 < str2) ? -1 : ((str1 > str2) ? 1 : 0));
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == null || str1 == "")
          return 1;
        if (str2 == null || str2 == "")
          return -1;
        return ((str1 < str2) ? 1 : ((str1 > str2) ? -1 : 0));
      }
    });
  }

  loadReduntantCardsList() {
    //debugger
    this.loaderService.display(true);
    var model: ReduntantCardModel = new ReduntantCardModel();
    model.AccountNumbers = [];
    model.Token = this.authService.getToken().access_token;
    //model.EndPointURL = ApiEndPoints.ReduntantCardsEndPoint;
    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    if (userData == undefined) {
      userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    }
    if (userData != null) {
      model.UserId = userData.sub;
    }
    this.accessAccounts.forEach(item => {
      model.AccountNumbers.push(item.name);
    });
    this.managedCardService.getReduntantCards(model)
      .subscribe(
      (reduntantCards: ReduntantCard[]) => {
        this.reduntantCardsList = reduntantCards;
        setTimeout(() => {
          this.afterloaddata();
          this.loaderService.display(false);
        }, 100);
      },
      (error: any) => {
        this.loaderService.display(false);
        this.managedCardService.showError("Redundant Cards retrieval problem", <any>error);
      }
    );
  }

  afterloaddata() {
    $('#reduntantdatatable').DataTable({
      //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      //columnDefs: [{ width: 32, targets: 0 }, { orderable: false, targets: [0, 7] }, { bSearchable: false, targets: [0, 5, 6, 7] }],
      columnDefs: [{ type: 'date-uk', targets: [4, 5] }, { "type": "non-empty-string", targets: [2, 3] }],
      fixedColumns: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Download <i class="fa fa-angle-down"></i>',
          //buttons: ['excelHtml5', 'csvHtml5', 'pdfHtml5'],
          buttons: [{
            extend: 'excelHtml5',
            title: 'Redundantcards',
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6],
              orthogonal: 'sort'
            },
            customizeData: function (data) {
              for (var i = 0; i < data.body.length; i++) {
                for (var j = 0; j < data.body[i].length; j++) {
                  data.body[i][j] = '\u200C' + data.body[i][j];
                }
              }
            }
          },
          //{
          //  extend: 'csvHtml5',
          //  title: 'reduntantcards',
          //  exportOptions: {
          //    columns: [1, 2, 3, 4, 5, 6]
          //  }
          //},
          {
            extend: 'pdfHtml5',
            title: 'Redundantcards',
            orientation: 'landscape',
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6]
            }
          }
          ]
        }
      ]
    });

    //Check All Functionality
    $('#reduntantdatatable thead th input[type=checkbox]').change(function () {
      var set = $("#reduntantdatatable tbody tr input[type=checkbox]");
      var checked = $(this).is(":checked");
      $(set).each(function () {
        if (checked) {
          $(this).prop("checked", true);
          $(this).parents('tr').addClass("active");
        } else {
          $(this).prop("checked", false);
          $(this).parents('tr').removeClass("active");
        }
      });

    });
    $('#reduntantdatatable tbody tr input[type=checkbox]').change(function () {
      $(this).parents('tr').toggleClass("active");
    });

    // DataTable
    var table = $('#reduntantdatatable').DataTable();

    // Apply the search
    table.columns().every(function () {
      var that = this;

      $('input', this.footer()).on('keyup change', function () {
        if (that.search() !== this.value) {
          that
            .search(this.value.replace(/\u200C/g, ''))
            .draw();
        }
      });
    });

    $('.dataTables_filter input', table.table().container())
      .off('.DT')
      .on('keyup.DT cut.DT paste.DT input.DT search.DT', function (e) {
        if (this.value.length >= 1) {
          // Call the API search function
          table.search(this.value.replace(/\u200C/g, '')).draw();
        }

        // Ensure we clear the search if they backspace far enough
        if (this.value === "") {
          table.search("").draw();
        }
      });


  }
  ngOnDestroy() {
    // prevent memory leak when component destroyed
    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    if (userData == undefined) {
      userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    }
    if (userData != undefined) {
      let UserId = userData.sub;
      this.managedCardService.ClearStopCardsMemory(UserId, "reduntantcards")
        .subscribe(
          (data: null) => {

          },
          (error: any) => {

          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/managecards/managedcards.reduntantcards.component.ts